import React from 'react';

import { TransitionGroup, CSSTransition } from 'react-transition-group';
import AddNewButton from '../buttons/AddNewButton';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';
import Table from 'react-bootstrap/Table';
import PagedListControl from './PagedListControl';

const ListView = ({
    addItem,
    animate,
    canAdd,
    className,
    isLoaded,
    itemName,
    items,
    pageInfo,
    tableHead
}) => {
    const animatedItems = (items && items.length > 0)
        ? items.map(item => (
            <CSSTransition
                key={item.key}
                timeout={300}
                classNames='list-item'>
                {item}
            </CSSTransition>
        ))
        : undefined;

    return (
        <React.Fragment>
            <Row>
                <Col className={className !== undefined ? className : 'list-holder'}>
                    <Table size='sm'>
                        {tableHead}
                        {animate ? (
                            <TransitionGroup component='tbody' className='animated'>
                                {animatedItems}
                            </TransitionGroup>
                        ) : (
                                <tbody>
                                    {items}
                                </tbody>
                            )}
                    </Table>
                    {isLoaded ? items && items.length === 0 &&
                        (
                            <div className='text-center'>
                                No Items Found
                            </div>
                        ) : !items || items.length === 0 &&
                        (
                            <div className='text-center'>
                                Loading...
                            </div>
                        )
                    }
                    {canAdd !== undefined &&
                    <div style={{ height: '38px' }}>
                        {addItem &&
                            <AddNewButton itemName={itemName} addItem={addItem} disabled={!canAdd} />
                        }
                        </div>
                    }
                </Col>
            </Row>
            {(isLoaded || items || items.length > 0) && pageInfo &&
                <Row>
                    <Col>
                        <PagedListControl {...pageInfo} />
                    </Col>
                </Row>
            }
        </React.Fragment>
    );
}

ListView.defaultProps = {
    animate: true,
    isLoaded: true
}

ListView.propTypes = {
    items: PropTypes.array,
    tableHead: PropTypes.element,
    canAdd: PropTypes.bool,
    itemName: PropTypes.string,
    addItem: PropTypes.func,
    isLoaded: PropTypes.bool
};

export default ListView;